var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvisoriesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.224121,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#3F46AB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3343_8969",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.22412,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3343_8969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 19.2241C20.3 19.2241 19.7083 18.9825 19.225 18.4991C18.7417 18.0158 18.5 17.4241 18.5 16.7241C18.5 16.0241 18.7417 15.4325 19.225 14.9491C19.7083 14.4658 20.3 14.2241 21 14.2241C21.7 14.2241 22.2917 14.4658 22.775 14.9491C23.2583 15.4325 23.5 16.0241 23.5 16.7241C23.5 17.4241 23.2583 18.0158 22.775 18.4991C22.2917 18.9825 21.7 19.2241 21 19.2241ZM16 23.2241V22.8241C16 22.4241 16.1042 22.0533 16.3125 21.7116C16.5208 21.37 16.8167 21.1241 17.2 20.9741C17.8 20.7241 18.4208 20.5366 19.0625 20.4116C19.7042 20.2866 20.35 20.2241 21 20.2241C21.65 20.2241 22.2958 20.2866 22.9375 20.4116C23.5792 20.5366 24.2 20.7241 24.8 20.9741C25.1833 21.1241 25.4792 21.37 25.6875 21.7116C25.8958 22.0533 26 22.4241 26 22.8241V23.2241C26 23.5075 25.9042 23.745 25.7125 23.9366C25.5208 24.1283 25.2833 24.2241 25 24.2241H17C16.7167 24.2241 16.4792 24.1283 16.2875 23.9366C16.0958 23.745 16 23.5075 16 23.2241ZM14 16.2241C12.9 16.2241 11.9583 15.8325 11.175 15.0491C10.3917 14.2658 10 13.3241 10 12.2241C10 11.1241 10.3917 10.1825 11.175 9.39912C11.9583 8.61579 12.9 8.22412 14 8.22412C15.1 8.22412 16.0417 8.61579 16.825 9.39912C17.6083 10.1825 18 11.1241 18 12.2241C18 13.3241 17.6083 14.2658 16.825 15.0491C16.0417 15.8325 15.1 16.2241 14 16.2241ZM6 21.4241C6 20.8575 6.14167 20.3366 6.425 19.8616C6.70833 19.3866 7.1 19.0241 7.6 18.7741C8.6 18.2741 9.6375 17.8908 10.7125 17.6241C11.7875 17.3575 12.8833 17.2241 14 17.2241C14.5833 17.2241 15.1667 17.2741 15.75 17.3741C16.3333 17.4741 16.9167 17.5908 17.5 17.7241L15.8 19.4241C15.5 19.3408 15.2 19.2866 14.9 19.2616C14.6 19.2366 14.3 19.2241 14 19.2241C13.0333 19.2241 12.0875 19.3408 11.1625 19.5741C10.2375 19.8075 9.35 20.1408 8.5 20.5741C8.33333 20.6575 8.20833 20.7741 8.125 20.9241C8.04167 21.0741 8 21.2408 8 21.4241V22.2241H14V23.1991C14 23.4158 14.0417 23.6116 14.125 23.7866C14.2083 23.9616 14.325 24.1075 14.475 24.2241H8C7.45 24.2241 6.97917 24.0283 6.5875 23.6366C6.19583 23.245 6 22.7741 6 22.2241V21.4241ZM14 14.2241C14.55 14.2241 15.0208 14.0283 15.4125 13.6366C15.8042 13.245 16 12.7741 16 12.2241C16 11.6741 15.8042 11.2033 15.4125 10.8116C15.0208 10.42 14.55 10.2241 14 10.2241C13.45 10.2241 12.9792 10.42 12.5875 10.8116C12.1958 11.2033 12 11.6741 12 12.2241C12 12.7741 12.1958 13.245 12.5875 13.6366C12.9792 14.0283 13.45 14.2241 14 14.2241Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvisoriesIcon);
export default __webpack_public_path__ + "static/media/Advisories_icon.ba4b03855db5a9764de6898a44228a45.svg";
export { ForwardRef as ReactComponent };